// recoil/authState.ts
import { atom } from "recoil";

export interface AuthState {
  userId: string | null;
  role: "user" | "admin" | null;
}

const getInitialAuthState = (): AuthState => {
  const userId = localStorage.getItem("userId");
  const role = localStorage.getItem("role");
  const token = localStorage.getItem("jwtToken");

  if (!token || !userId || (role !== "user" && role !== "admin")) {
    return {
      userId: null,
      role: null,
    };
  }

  return {
    userId,
    role,
  };
};

export const authState = atom<AuthState>({
  key: "authState",
  default: getInitialAuthState(),
});
